import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Col,
    Row,
    Spin,
    Form as FormInitial,
    message,
    Select,
    Tag,
} from "antd";
import {
    BoxItem,
    ButtonItem,
    Form,
    HeaderItem,
    InputNumberItem,
    SelectItem,
    TextAreaItem,
    FormItem,
    DatePickerItem,
    SelectInsumosItem,
    ModalItem,
    SwitchItem,
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import VerRequisicionPdf from "../EditarRequisicion/VerRequisicionPdf/VerRequisicionPdf";
import { ArrowUpOutlined, CarOutlined, EnvironmentOutlined, FireOutlined, InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";

const { Option } = Select;

class ModalVerRequisicion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        todasProveedores: null,
        objetoProveedoresPInsumos: [],
        objetoProyectos: null,
        todasProyectos: null,
        objetoInsumos: null,
        todasInsumos: [],
        impuestos: [],
        numeroRequisicion: 0,
        presupuestoPU: false,
        presupuestoPUId: null,
        modalVerPdf: false,
        modalVerPdfId: null,
        todosUsuarios: [],
        objetoUsuarios: null,
        proyectoId: null,
        requisicionesAdicionales: [],
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible && this.props.visible !== prevProps.visible) {
            this.consultarTodo(true);
        }
    }

    promisedSetState = (newState) =>
        new Promise((resolve) => this.setState(newState, resolve));

    abrirModalVerPdf() {
        this.setState({ modalVerPdf: true, modalVerPdfId: this.props.requisicionId });
    }

    cerrarModalVerPdf() {
        this.setState({ modalVerPdf: false, modalVerPdfId: null });
    }

    async consultarTodo(resetForm = false) {
        this.setState({ loading: true });

        const responseProveedores = axios.post(
            "proveedores/selectProveedoresConTipoDeProveedor",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
        );

        const responseProyectos = axios.post(
            "proyectos/selectProyectos",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
        );

        axios
            .post(
                "usuarios/selectUsuariosEmpresa",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) return [];
                this.setState({
                    todosUsuarios: res.data,
                    objetoUsuarios: res.data.map((value) => (
                        <Option value={value._id} key={value._id}>
                            {value.nombre} {value.apellidoPaterno} {value.apellidoMaterno}
                        </Option>
                    )),
                });
            });

        const responses = await Promise.all([responseProveedores, responseProyectos]);

        let newState = {};
        if (responses[0].data.status !== 404) {
            newState.todasProveedores = responses[0].data;
            newState.objetoProveedores = responses[0].data.map((value) => (
                <Option value={value._id} key={value._id}>
                    {value.stringBuscar}
                </Option>
            ));
        }
        if (responses[1].data.status !== 404) {
            newState.todasProyectos = responses[1].data;
            newState.objetoProyectos = responses[1].data.map((value) => (
                <Option value={value._id} key={value._id}>
                    {value.nombre}
                </Option>
            ));
        }

        await this.promisedSetState(newState);

        let secondState = { loading: false };

        await axios
            .post(
                "requisiciones/datosRequisicion",
                {
                    empresaId: this.props.empresaId,
                    requisicionId: this.props.requisicionId,
                },
                { headers: this.props.headersToken }
            )
            .then(async (res) => {
                if (res.data.success === 2) {
                    this.setState({
                        proyectoId: res.data.requisicion.proyectoId,
                        requisicionesAdicionales: res.data.requisicionesAdicionales,
                    });

                    if (resetForm && this.formRef.current) {
                        this.formRef.current.resetFields();
                    }

                    this.formRef.current?.setFieldsValue({
                        ...res.data.requisicion,
                        solicitanteId:
                            res.data.requisicion.solicitanteId || res.data.requisicion.usuarioId,
                        fechaEntrega: res.data.requisicion.fechaEntrega ? moment(res.data.requisicion.fechaEntrega) : null,
                        fechaSolicitud: res.data.requisicion.fechaSolicitud
                            ? moment(res.data.requisicion.fechaSolicitud)
                            : null,
                    });

                    // Inventarios por insumo/proyecto:
                    if (res.data.requisicion.insumos && res.data.requisicion?.insumos?.length > 0) {
                        const inventarioPromises = res.data.requisicion.insumos.map(
                            async (valueInsumo, index) => {
                                const insumo = res.data.insumos.find(
                                    (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
                                );
                                if (insumo && (insumo.inventariable || insumo.insumoCompuesto)) {
                                    try {
                                        const inventarioRes = await axios.post(
                                            "inventarios/inventarioInsumoProyecto",
                                            {
                                                proyectoId: this.state.proyectoId,
                                                insumoId: valueInsumo.insumoId,
                                                noPrincipal: insumo.noPrincipal,
                                                insumoCompuesto: insumo.insumoCompuesto,
                                                empresaId: this.props.empresaId,
                                                pedidosSeleccionados: this.state.pedidosSeleccionados,
                                            },
                                            { headers: this.props.headersToken }
                                        );
                                        return { index, inventario: inventarioRes.data.cantidad };
                                    } catch (error) {
                                        console.error("Error al obtener inventario:", error);
                                        return { index, inventario: null };
                                    }
                                } else if (insumo) {
                                    return { index, inventario: "No inventariable" };
                                }
                                return { index, inventario: null };
                            }
                        );

                        const inventarios = await Promise.all(inventarioPromises);
                        let insumosConInventario = [...res.data.requisicion.insumos];
                        inventarios.forEach(({ index, inventario }) => {
                            if (inventario !== null) insumosConInventario[index].inventario = inventario;
                        });

                        this.formRef.current?.setFieldsValue({
                            insumos: insumosConInventario,
                        });

                        // Proveedores disponibles por insumo:
                        let objetoProveedoresPInsumos =
                            res.data.requisicion.insumos.map((valueInsumo) => {
                                const insumo = res.data.insumos.find(
                                    (valueInsumos) => valueInsumos._id === valueInsumo.insumoId
                                );

                                if (!insumo)
                                    return (
                                        <Option value={0} key={0} disabled>
                                            Seleccione un insumo para ver sus proveedores
                                        </Option>
                                    );

                                let objetoProveedores = [];
                                if (insumo.relaciones && insumo.relaciones?.length > 0) {
                                    let keysProveedores = [];
                                    for (const relacion of insumo.relaciones) {
                                        if (relacion.estado !== 0) {
                                            const i = keysProveedores.findIndex(
                                                (v) => v.toString() === relacion.proveedorId.toString()
                                            );
                                            if (i === -1) keysProveedores.push(relacion.proveedorId.toString());
                                        }
                                    }
                                    for (const proveedorId of keysProveedores) {
                                        const proveedor = this.state.todasProveedores?.find(
                                            (v) => v._id.toString() === proveedorId.toString()
                                        );
                                        if (!proveedor) continue;
                                        objetoProveedores.push(
                                            <Option value={proveedor._id} key={proveedor._id}>
                                                {proveedor.stringBuscar}
                                            </Option>
                                        );
                                    }
                                }
                                return objetoProveedores;
                            });

                        secondState.objetoProveedoresPInsumos = objetoProveedoresPInsumos;
                    }

                    secondState.numeroRequisicion = res.data.requisicion.numero;
                    secondState.presupuestoPU = res.data.requisicion.presupuestoPU;
                    secondState.presupuestoPUId = res.data.requisicion.presupuestoPUId;
                    secondState.todasInsumos = res.data.insumos;
                } else {
                    message.error("Error: no se encontró información de la requisición");
                }
            });

        await this.promisedSetState(secondState);
    }

    render() {
        const { visible, onClose } = this.props;

        return (
            <ModalItem
                title={`Ver Requisición #${this.state.numeroRequisicion || ""}`}
                visible={visible}
                spinning={this.state.loading}
                paddingTop
                onCancel={onClose}
            >
                <div className="card-background">
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="ModalVerRequisicion"
                            layout
                            bottom={
                                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                                    <ButtonItem type="primary" blanco onClick={() => this.abrirModalVerPdf()}>
                                        Ver Requisición
                                    </ButtonItem>
                                    <ButtonItem onClick={onClose}>Cerrar</ButtonItem>
                                </div>
                            }
                        >
                            <Row>
                                <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                    <HeaderItem>DATOS GENERALES</HeaderItem>
                                    <BoxItem>
                                        <Row>
                                            <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                                <FormItem
                                                    label="Fecha Solicitud"
                                                    name="fechaSolicitud"
                                                    margin
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 21 }}
                                                >
                                                    <DatePickerItem
                                                        disabled
                                                        placeholder="Fecha de Solicitud"
                                                    />
                                                </FormItem>
                                                <FormItem
                                                    label="Fecha Entrega"
                                                    name="fechaEntrega"
                                                    margin
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 21 }}
                                                >
                                                    <DatePickerItem
                                                        disabled
                                                        placeholder="Fecha de Entrega"
                                                    />
                                                </FormItem>
                                                <FormItem
                                                    label="Solicitante"
                                                    name="solicitanteId"
                                                    tooltip="Usuario que solicita la requisición; si no se selecciona, se asigna al usuario que crea la requisición por defecto."
                                                    margin
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 21 }}
                                                >
                                                    <SelectItem disabled placeholder="Seleccione al solicitante">
                                                        {this.state.objetoUsuarios}
                                                    </SelectItem>
                                                </FormItem>
                                                <FormItem
                                                    labelCol={{ span: 3 }}
                                                    wrapperCol={{ span: 21 }}
                                                    label="Proyecto"
                                                    name="proyectoId"
                                                    margin
                                                    required
                                                >
                                                    <SelectItem disabled placeholder="Proyecto">
                                                        {this.state.objetoProyectos}
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </BoxItem>
                                </Col>

                                <Col span={24} xs={24} sm={24} lg={24} xl={24}>
                                    <HeaderItem>EXTRAS</HeaderItem>
                                    <BoxItem>
                                        <FormItem
                                            label="Separar Ins:"
                                            name="separarInsumos"
                                            margin
                                            initialValue={true}
                                            valuePropName="checked"
                                            tooltip="¿Esto indicara al momento de recibir la orden de compra, que se separen los insumos?"
                                            labelCol={{ span: 3 }}
                                            wrapperCol={{ span: 21 }}
                                        >
                                            <SwitchItem disabled />
                                        </FormItem>
                                        <FormItem
                                            label="Importancia"
                                            name="importancia"
                                            tooltip="Nivel de importancia: 1 = Baja, 2 = Media, 3 = Alta"
                                            margin
                                            labelCol={{ span: 3 }}
                                            wrapperCol={{ span: 21 }}
                                        >
                                            <SelectItem placeholder="Seleccione nivel de importancia" style={{ width: "100%" }}>
                                                <Option value={1}>
                                                    <Tag color="green" style={{ marginRight: 8 }}>
                                                        <ArrowUpOutlined /> Baja
                                                    </Tag>
                                                </Option>
                                                <Option value={2}>
                                                    <Tag color="orange" style={{ marginRight: 8 }}>
                                                        <WarningOutlined /> Media
                                                    </Tag>
                                                </Option>
                                                <Option value={3}>
                                                    <Tag color="red" style={{ marginRight: 8 }}>
                                                        <FireOutlined /> Alta
                                                    </Tag>
                                                </Option>
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem
                                            label="Observaciones"
                                            name="observaciones"
                                            margin
                                            labelCol={{ span: 3 }}
                                            wrapperCol={{ span: 21 }}
                                            pattern
                                        >
                                            <TextAreaItem disabled placeholder="Observaciones" />
                                        </FormItem>
                                    </BoxItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <FormItem shouldUpdate noStyle>
                                        {({ getFieldValue }) => {
                                            let proyectoId = getFieldValue("proyectoId");
                                            if (!proyectoId)
                                                return null;
                                            let proyecto = this.state.todasProyectos.find(
                                                (value) => value._id === proyectoId
                                            );
                                            return (
                                                <div
                                                    style={{
                                                        background: "#f9fafb",
                                                        border: "1px solid #e5e7eb",
                                                        borderRadius: 8,
                                                        padding: "10px 16px",
                                                        marginTop: 8,
                                                        boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                                                    }}
                                                >
                                                    <Row gutter={[12, 8]} align="middle">
                                                        {/* Columna 1: Proyecto */}
                                                        <Col xs={24} md={8}>
                                                            <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                                                                <InfoCircleOutlined style={{ color: "#1890ff", marginRight: 6, fontSize: 14 }} />
                                                                <span style={{ fontWeight: 600, color: "#333", fontSize: 13 }}>Proyecto</span>
                                                            </div>
                                                            <p style={{ margin: 0, fontSize: 13 }}>
                                                                <strong>Nombre:</strong> {proyecto.nombre || "-"}
                                                            </p>
                                                            <p style={{ margin: 0, fontSize: 13 }}>
                                                                <strong>Desc:</strong> {proyecto.descripcion || "-"}
                                                            </p>
                                                        </Col>

                                                        {/* Columna 2: Dirección o vehículo */}
                                                        <Col xs={24} md={8}>
                                                            <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                                                                <EnvironmentOutlined style={{ color: "#52c41a", marginRight: 6, fontSize: 14 }} />
                                                                <span style={{ fontWeight: 600, color: "#333", fontSize: 13 }}>Dirección / Vehículo</span>
                                                            </div>
                                                            {proyecto.calle ? (
                                                                <p style={{ margin: 0, fontSize: 13 }}>
                                                                    {proyecto.calle} #{proyecto.numeroCalle || "-"}
                                                                </p>
                                                            ) : (
                                                                <p style={{ margin: 0, fontSize: 13 }}>
                                                                    {proyecto.marca || "-"} · {proyecto.modelo || "-"} · {proyecto.placas || "-"}
                                                                </p>
                                                            )}
                                                        </Col>

                                                        {/* Columna 3: Información adicional */}
                                                        <Col xs={24} md={8}>
                                                            <div style={{ display: "flex", alignItems: "center", marginBottom: 4 }}>
                                                                <CarOutlined style={{ color: "#faad14", marginRight: 6, fontSize: 14 }} />
                                                                <span style={{ fontWeight: 600, color: "#333", fontSize: 13 }}>Detalles</span>
                                                            </div>
                                                            {proyecto.calle ? (
                                                                <p style={{ margin: 0, fontSize: 13 }}>
                                                                    <strong>Tipo:</strong> Dirección física
                                                                </p>
                                                            ) : (
                                                                <p style={{ margin: 0, fontSize: 13 }}>
                                                                    <strong>Tipo:</strong> Vehículo
                                                                </p>
                                                            )}
                                                            <p style={{ margin: 0, fontSize: 13 }}>
                                                                <strong>ID:</strong> {proyecto._id?.slice(-6).toUpperCase() || "—"}
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        }}
                                    </FormItem>
                                </Col>
                            </Row>

                            <HeaderItem>INSUMOS</HeaderItem>
                            <BoxItem>
                                <FormInitial.List name="insumos">
                                    {(fields, { add /*, remove*/ }) => (
                                        <>
                                            <table className="table">
                                                {fields.length > 0 ? (
                                                    <thead>
                                                        <tr>
                                                            <th className="th-border" style={{ width: "40%" }}>
                                                                Insumo
                                                            </th>
                                                            <th className="th-border" style={{ width: "15%" }}>
                                                                Inventario
                                                            </th>
                                                            <th className="th-border" style={{ width: "15%" }}>
                                                                Cantidad
                                                            </th>
                                                            <th className="th-border" style={{ width: "10%" }}>
                                                                Req.
                                                            </th>
                                                            <th className="th-border" style={{ width: "40%" }}>
                                                                Proveedor
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                ) : null}

                                                {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => (
                                                    <tbody key={arrayKey}>
                                                        <FormItem noStyle shouldUpdate>
                                                            {({ getFieldValue }) => {
                                                                const insumos = getFieldValue("insumos") || [];
                                                                const insumo = insumos[arrayKey] || {};
                                                                const origenesRequisicion = Array.isArray(insumo.requisicionesOrigen) && insumo.requisicionesOrigen.length > 0
                                                                    ? insumo.requisicionesOrigen
                                                                    : (insumo.requisicionId ? [{ requisicionId: insumo.requisicionId, cantidad: insumo.cantidad }] : []);
                                                                const nombresRequisicion = origenesRequisicion
                                                                    .map(origen => this.state.requisicionesAdicionales.find((r) => r._id === origen.requisicionId))
                                                                    .filter(Boolean)
                                                                    .map((reqAdic) => reqAdic.numero);

                                                                return (
                                                                    <tr>
                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "insumoId"]}
                                                                                required
                                                                                noStyle
                                                                            >
                                                                                <SelectInsumosItem
                                                                                    empresaId={this.props.empresaId}
                                                                                    headersToken={this.props.headersToken}
                                                                                    sinBorde
                                                                                    autoFocus
                                                                                    dropdownMatchSelectWidth={600}
                                                                                    width="100%"
                                                                                    placeholder="Insumo"
                                                                                    tiposInsumos="compra"
                                                                                    disabled
                                                                                />
                                                                            </FormItem>
                                                                        </td>

                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "inventario"]}
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    placeholder="Inventario"
                                                                                />
                                                                            </FormItem>
                                                                        </td>

                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "cantidad"]}
                                                                                required
                                                                                number
                                                                                noStyle
                                                                            >
                                                                                <InputNumberItem
                                                                                    sinBorde
                                                                                    disabled
                                                                                    placeholder="Cantidad"
                                                                                />
                                                                            </FormItem>
                                                                        </td>

                                                                        <td className="td-border" style={{ textAlign: "center" }}>
                                                                            {nombresRequisicion.map((n, idx) => (
                                                                                <Tag color="blue" key={idx} style={{ marginBottom: 4 }}>{`Req. ${n}`}</Tag>
                                                                            ))}
                                                                        </td>

                                                                        <td className="td-border">
                                                                            <FormItem
                                                                                {...restField}
                                                                                name={[name, "proveedorId"]}
                                                                                margin
                                                                                noStyle
                                                                            >
                                                                                <SelectItem
                                                                                    sinBorde
                                                                                    style={{ width: "100%" }}
                                                                                    placeholder="Proveedor"
                                                                                    disabled
                                                                                >
                                                                                    {
                                                                                        this.state.objetoProveedoresPInsumos[
                                                                                        arrayKey
                                                                                        ]
                                                                                    }
                                                                                </SelectItem>
                                                                            </FormItem>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }}
                                                        </FormItem>
                                                        <FormItem
                                                            noStyle
                                                            shouldUpdate={(prev, curr) =>
                                                                prev.insumos[arrayKey]?.observaciones !==
                                                                curr.insumos[arrayKey]?.observaciones
                                                            }
                                                        >
                                                            {({ getFieldValue }) => {
                                                                let arrayValue = getFieldValue("insumos");
                                                                if (arrayValue[arrayKey]?.observaciones) {
                                                                    return (
                                                                        <tr>
                                                                            <td
                                                                                colSpan="9"
                                                                                className="td-border-sin-right"
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "left",
                                                                                        alignItems: "left",
                                                                                        backgroundColor: "white",
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        style={{
                                                                                            width: "90%",
                                                                                            textAlign: "left",
                                                                                            paddingLeft: 20,
                                                                                        }}
                                                                                    >
                                                                                        {/* <b>Observaciones:</b><br /> */}
                                                                                        {String(
                                                                                            arrayValue[arrayKey]
                                                                                                .observaciones
                                                                                        )
                                                                                            .split(/\r?\n/)
                                                                                            .map((line, i) => (
                                                                                                <span key={i}>
                                                                                                    {line}
                                                                                                    <br />
                                                                                                </span>
                                                                                            ))}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            }}
                                                        </FormItem>
                                                    </tbody>
                                                ))}
                                            </table>
                                        </>
                                    )}
                                </FormInitial.List>
                            </BoxItem>
                        </Form>
                    </Spin>
                </div>

                <VerRequisicionPdf
                    visible={this.state.modalVerPdf}
                    requisicionId={this.state.modalVerPdfId}
                    onCancel={this.cerrarModalVerPdf.bind(this)}
                    cerrarModalVerPdf={this.cerrarModalVerPdf.bind(this)}
                />
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalVerRequisicion);
